// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Es6Promise from 'es6-promise'

require("es6-promise").polyfill()
Es6Promise.polyfill()
import Vue from 'vue'
import App from './App'
import router from './router'

import axios from 'axios'
import store from './vuex/store'
import global_ from './Global.vue'

Vue.prototype.GLOBAL = global_
axios.defaults.baseURL = global_.BASE_URL
axios.defaults.withCredentials = true
Vue.prototype.$http = axios
Vue.config.productionTip = false

// alert(global_.KTX_TOKEN_NAME)
import VueWechatTitle from 'vue-wechat-title'

Vue.use(VueWechatTitle)

import qs from 'qs'

Vue.prototype.$qs = qs

import utils from "./service/utils.js"

Vue.prototype.$utils = utils

import animated from 'animate.css'
Vue.use(animated);

import loginService from"./service/base/LoginService.js"
// let ktxloading = document.getElementById('ktx-loading')
// alert(global_.KTX_TOKEN_NAME)
axios.interceptors.request.use(
    config => {
        // let token = "2a84e27e9235b6928b7dd815993ab7d1"
        // localStorage.setItem("ktxToken", token)

        let ktxToken = localStorage.getItem(global_.KTX_TOKEN_NAME)
        // alert(ktxToken)
        if (ktxToken &&ktxToken!='' &&ktxToken!='undefined'&& typeof(ktxToken) != "undefined") {
            // alert(typeof(ktxToken) )
            config.headers['ktxToken'] = ktxToken
        }
        return config
    },
    function (error) {
        // document.getElementById('ktx-loading').style.display = 'none'
        return Promise.reject(error)
    }
)

axios.interceptors.response.use(function (response) {
    // document.getElementById('ktx-loading').style.display = 'none'
    //  对响应数据做些事
    if(response.data&&response.data.status&&(response.data.status==303||response.data.status==212)){
        loginService.removeToken()
        alert('登录凭证失效，请重新登录 code:'+response.data.status)
        location.reload()
    }

    return response
}, function (error) {
    // document.getElementById('ktx-loading').style.display = 'none'
    //  请求错误时做些事
    return Promise.reject(error)
})

// 忽略自定义元素标签抛出的报错
Vue.config.ignoredElements = ['wx-open-launch-app'];

new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})


// 打印log
// import Vconsole from 'vconsole';
//     const vConsole = new Vconsole();
//     Vue.use(vConsole)
// if (process.env.NODE_ENV === "development") {

// }
// Vue.directive('resetPage', {
//     inserted: function (el) {
//
//         // 监听键盘收起事件
//         document.body.addEventListener('focusout', () => {
//             if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
//             //软键盘收起的事件处理
//             setTimeout(() => {
//                 const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
//                 window.scrollTo(0, Math.max(scrollHeight - 1, 0))
//         }, 100)
//         }
//     })
//     }
// })






// WEBPACK FOOTER //
// ./src/main.js